import React, { FC, useRef, useEffect, useState } from 'react';
import { TooltipPortalProps } from '../types/infoToolTip.types';
import { documentService, windowService } from '../../../../utils/window.utils.js';

const TooltipPortal: FC<TooltipPortalProps> = ({ getTooltipIconDimensions, width, children, tooltipVisibility }) => {
  const TooltipRef = useRef<HTMLDivElement | null>(null);

  const [stylesArrow, setStylesArrow] = useState({});
  const [stylesBox, setStylesBox] = useState({});

  useEffect(() => {
    function reposition(): void {
      if (tooltipVisibility && TooltipRef && TooltipRef.current) {
        const eleDim = getTooltipIconDimensions();
        TooltipRef.current.style.top = eleDim.top + eleDim.height + 'px';
        TooltipRef.current.style.left = eleDim.left + eleDim.width / 2 + 'px';
      }
    }

    reposition();

    windowService().addEventListener('scroll', reposition);
    return (): void => windowService().removeEventListener('scroll', reposition);
  }, [TooltipRef, tooltipVisibility]); // eslint-disable-line

  useEffect(() => {
    function positionToolTip(ToolTipIconEl: DOMRect, width: number) {
      const spaceLeft = ToolTipIconEl?.left;
      const customDocument = documentService();
      const clientWidth = customDocument?.documentElement.clientWidth;
      const spaceRight = clientWidth - ToolTipIconEl?.right;
      let halfWidth = width / 2;
      let availableWidth = width;
      if (width > clientWidth) {
        availableWidth = clientWidth - 20;
        halfWidth = availableWidth / 2;
      }
      if (spaceLeft < halfWidth && spaceRight < halfWidth) {
        setStylesArrow({
          left: '50%',
        });
        setStylesBox({
          width: 'auto',
        });
      } else if (spaceLeft < halfWidth) {
        const availableSpace = halfWidth - spaceLeft;
        setStylesArrow({
          left: `calc(50% - ${availableSpace}px)`,
        });
        setStylesBox({
          width: `${availableWidth}px`,
          left: `${availableSpace}px`,
          transform: 'translate(calc(-50%, 100%)',
        });
      } else if (spaceRight < halfWidth) {
        const availableSpace = spaceRight - halfWidth;
        setStylesArrow({
          left: `calc(50% - ${availableSpace}px)`,
        });
        setStylesBox({
          width: `${availableWidth}px`,
          left: `${availableSpace}px`,
          transform: 'translate(calc(-50%, 100%)',
        });
      } else {
        setStylesArrow({
          left: '50%',
        });
        setStylesBox({ width: `${availableWidth}px` });
      }
    }
    function handleTooltipPosition(): void {
      if (width && TooltipRef && TooltipRef.current) {
        const ToolTipIconEl = getTooltipIconDimensions();
        if (!ToolTipIconEl) return;
        positionToolTip(ToolTipIconEl, width);
      }
    }

    handleTooltipPosition();
    windowService().addEventListener('resize', handleTooltipPosition);
    return (): void => windowService().removeEventListener('resize', handleTooltipPosition);
  }, [width]); // eslint-disable-line

  return (
    <div ref={TooltipRef} className="tooltip-portal">
      <div className={`tooltip-portal__children ${!tooltipVisibility && 'tooltip-portal__children--hidden'}`} style={stylesBox}>
        <div className="tooltip-portal__arrow" style={stylesArrow} />
        {children}
      </div>
    </div>
  );
};

export default TooltipPortal;
